/**
 * External dependencies
 */
import clsx from "clsx";

/**
 * WordPress dependencies
 */
import {
  __experimentalGetBorderClassesAndStyles as getBorderClassesAndStyles,
  __experimentalGetShadowClassesAndStyles as getShadowClassesAndStyles,
  useBlockProps,
} from "@wordpress/block-editor";

export default function save({ attributes }) {
  const { iconName, iconType } = attributes;

  const borderProps = getBorderClassesAndStyles(attributes);
  const shadowProps = getShadowClassesAndStyles(attributes);

  const classes = clsx(borderProps.className);

  const blockProps = useBlockProps.save({
    className: classes,
    style: {
      ...borderProps.style,
      ...shadowProps.style,
      width: "fit-content",
    },
  });

  return (
    <div {...blockProps}>
      {" "}
      <i
        className={`ph${
          iconType !== "regular" ? "-" + iconType : ""
        } ph-${iconName}`}
      ></i>
    </div>
  );
}
